import { FunctionComponent, MouseEvent, memo, useCallback } from 'react';
import { OrganisationTagExternal } from '../../../services';
import { useTagFollow } from '../../hooks';
import { FeedFollowBehavior } from '../../models';
import { FollowChip } from '../FollowChip';

interface TagFollowChipProps {
  tag: OrganisationTagExternal;
  truncate?: boolean;
  className?: string;
}

export const TagFollowChip: FunctionComponent<TagFollowChipProps> = memo(
  ({ tag, truncate, className }) => {
    const { isTagFollowed, toggleTagFollow, isFollowPending } = useTagFollow();

    const { name, settings } = tag;

    const handleClick = useCallback(
      (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        toggleTagFollow(tag);
      },
      [tag, toggleTagFollow]
    );

    if (settings.feedFollowBehavior === FeedFollowBehavior.MANDATORY) {
      return null;
    }

    return (
      <FollowChip
        label={name}
        followed={isTagFollowed(tag)}
        isPending={isFollowPending}
        onClick={handleClick}
        truncate={truncate}
        className={className}
      />
    );
  }
);
